import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import Service from "@/pages/Service";
import Huisdieren from "@/pages/Huisdieren";
import Events from "@/pages/Events";
import VrijWerk from "@/pages/VrijWerk";
import MagicMirror from "@/pages/MagicMirror";
import AudioGastenboek from "@/pages/AudioGastenboek";
// Studio & StudioSpecial pages currently hidden (studio not yet in service)
import OverEric from "@/pages/OverEric";
import Contact from "@/pages/Contact";
import Cadeaubonnen from "@/pages/Cadeaubonnen";
import CadeaubonSuccess from "@/pages/CadeaubonSuccess";
import Opties from "@/pages/Opties";
import Voorwaarden from "@/pages/Voorwaarden";
import VerhuurvoorwaardenMagicMirror from "@/pages/VerhuurvoorwaardenMagicMirror";
import Admin from "@/pages/Admin";
import MiniShoots from "@/pages/MiniShoots";
import EventBevestiging from "@/pages/EventBevestiging";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/vrij-werk" element={<VrijWerk />} />
            <Route path="/huwelijk" element={<Service />} />
            <Route path="/zwangerschap" element={<Service />} />
            <Route path="/newborn" element={<Navigate to="/zwangerschap" replace />} />
            <Route path="/gezin" element={<Service />} />
            <Route path="/communie" element={<Service />} />
            <Route path="/huisdieren" element={<Huisdieren />} />
            <Route path="/bedrijven" element={<Service />} />
            <Route path="/events" element={<Events />} />
            <Route path="/magic-mirror" element={<MagicMirror />} />
            <Route path="/audio-gastenboek" element={<AudioGastenboek />} />
            <Route path="/studio" element={<Navigate to="/" replace />} />
            <Route path="/studio-special" element={<Navigate to="/" replace />} />
            <Route path="/over-eric" element={<OverEric />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cadeaubonnen" element={<Cadeaubonnen />} />
            <Route path="/cadeaubon-success" element={<CadeaubonSuccess />} />
            <Route path="/opties" element={<Opties />} />
            <Route path="/voorwaarden" element={<Voorwaarden />} />
            <Route
              path="/verhuurvoorwaarden-magic-mirror"
              element={<VerhuurvoorwaardenMagicMirror />}
            />
            <Route path="/privacybeleid" element={<Navigate to="/voorwaarden" replace />} />
            <Route path="/mini-shoots" element={<MiniShoots />} />
            <Route path="/mini-shoots/bevestiging" element={<EventBevestiging />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
